import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { DriverPassengerRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/driver-passenger-identification-remote-action-builder/driver-passenger-identification-remoteaction-builder';
import { GenericRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/remote-action-builder';
import { MileageRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/mileage-remote-action-builder/mileage-remoteaction-builder';
import { CarsService } from '../../cars/logic/cars.service';
import { TourService } from '../../tour/logic/tour.service';

@Injectable({
  providedIn: 'root',
})
export class MileageActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'mileage';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private carsService: CarsService,
    private locationService: LocationService,
    private appParameterService: AppParameterService,
    private employeeService: EmployeeService, 
    private tourService: TourService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    const primaryCarId = this.employeeService.me$.getValue()?.primarycar?.id;
    const primaryCar = this.carsService.getCarById(primaryCarId);

    const tourId = this.clientStateService.theState.getValue()?.tourId;
    const tour = this.tourService.getTourById(tourId);
    const tourCar = this.carsService.getCarById(tour?.car?.id);

    const rab: GenericRemoteActionBuilder = new MileageRemoteActionBuilder(
      this.clientStateService,
      this.appService,
      this.credentialsService,
      this.carsService,
      this.locationService,
      this.appParameterService,
      tourCar ?? primaryCar,
      this.logger
    );
    this.remoteActionBuilderService.newBuild(rab);
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
